import { render, staticRenderFns } from "./DynamicEdit.vue?vue&type=template&id=04847ea1&scoped=true&"
import script from "./DynamicEdit.vue?vue&type=script&lang=js&"
export * from "./DynamicEdit.vue?vue&type=script&lang=js&"
import style0 from "./DynamicEdit.vue?vue&type=style&index=0&id=04847ea1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04847ea1",
  null
  
)

export default component.exports